import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Language } from "src/app/shared/models/language";
import { TextBlock } from "src/app/shared/models/text-block";
import { PublicSurveyService } from "src/app/shared/services/public-survey.service";
import { PublicTextBlockService } from "src/app/shared/services/public-text-block.service";
import { validateForm } from "src/app/shared/validators";

@Component({
    selector: "app-parent-search-by-key-page",
    templateUrl: "./parent-search-by-key-page.component.html",
    styleUrls: ["./parent-search-by-key-page.component.scss"],
    standalone: false
})
export class ParentSearchByKeyPageComponent implements OnInit {
  loginForm: UntypedFormGroup;
  errorMessage: string;
  instructions: TextBlock;
  languages: Language[];

  constructor(
    private fb: UntypedFormBuilder,
    private publicSurveyService: PublicSurveyService,
    private publicTextBlockService: PublicTextBlockService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  async ngOnInit(): Promise<void> {
    let surveyKey = this.route.snapshot.paramMap.get("surveyKey");

    this.loginForm = this.fb.group({
      surveyKey: [
        surveyKey,
        {
          validators: [Validators.required],
        },
      ],
      languageId: [
        "en",
        {
          validators: [Validators.required],
        },
      ],
    });

    this.languages = await this.publicSurveyService
      .getLanguagesForCurrentSurvey('parent-survey')
      .toPromise();

    this.instructions = await this.publicTextBlockService
      .getBlock("parent-survey-instructions")
      .toPromise();
  }

  async onSubmit() {
    this.errorMessage = null;

    this.loginForm.markAllAsTouched();
    this.loginForm.updateValueAndValidity();

    if (this.loginForm.valid) {
      await this.publicSurveyService
        .search(this.loginForm.get("surveyKey").value)
        .toPromise()
        .then((administrativeUnitSurveyId: string) => {
          this.router.navigate([
            "public",
            "parentsurveys",
            8,
            this.loginForm.get("languageId").value,
            administrativeUnitSurveyId,
          ]);
        })
        .catch((error: any) => {
          if (error.status === 404) {
            this.errorMessage = "Survey not found, please check key.";
          } else {
            this.errorMessage = "Error getting survey, please try again.";
          }
        });
    }
  }

  getErrorMessage(key: string): string {
    return validateForm(this.loginForm, key);
  }
}
